import {Col, Container, Row, media} from 'styled-bootstrap-grid';
import {Helmet} from "react-helmet";
import PageTitle from "../../../PageTitle/components/PageTitle";
import React, {Fragment} from 'react';
import styled from 'styled-components';
import {withRouter} from 'react-router-dom';
import PageNavigation from "../../../PageNavigation/components/PageNavigation";
import GetInTouch from "../../../GetInTouch/components/GetInTouch";
import ViewMoreLink from "../../../ViewMoreLink/components/ViewMoreLink";

const Img = styled.img`
  width: 100%;
`;
const H3 = styled.h3`
  font-weight: 400;
  font-size: 1.7rem;
  margin: 0 0 1rem;
`;
// const InfoTag = styled.p`
//   font-size: 1rem;
//   font-weight: 400;
//   text-transform: uppercase;
//   letter-spacing: 0.2rem;
//   color: #717476;
//   margin: 0 0 0.5rem;
// `;
const P = styled.p`
  color: #717476;
  font-size: 1.25rem;
  font-weight: 400;
  line-height: 2.5rem;
`;
const StyledRow = styled(Row)`
  padding-top: 4rem;
  padding-bottom: 4rem;
`;
const StyledCol = styled(Col)`
  margin-bottom: 4rem;
  
  ${media.lg`
    margin-bottom: 0;
  `}
`;

const IndustryTagWrap = styled.div`
  margin-bottom: 4rem;
`;
const IndustryTag = styled.div`
  display: inline-block;
  padding: 0 2rem;
  border: 1px solid #d7d7d7;
  border-radius: 5px;
  margin-right: 1rem;
  height: 3rem;
  border-radius: 2rem;
  text-align: center;
  font-size: 0.8rem;
  letter-spacing: 0.2rem;
  line-height: 3rem;
  text-transform: uppercase;
`;

const ServiceList = styled.ul`
  margin: 0;
  padding: 0;
  list-style-type: none;
  border-top: 1px solid #d7d7d7;
`;
const ServiceItem = styled.li`
  display: block;
  border-bottom: 1px solid #d7d7d7;
  padding: 1rem;
`;
const ServiceTag = styled.p`
  font-size: 1rem;
  font-weight: 400;
  text-transform: uppercase;
  letter-spacing: 0.2rem;
  color: #717476;
  margin: 0;
`;
const ServiceName = styled.p`
  color: #212529;
  font-size: 1.25rem;
  font-weight: 400;
  margin: 0;
`;

const LightWrap = styled.div`
  background: #fff;
  padding: ${({padding}) => (padding) ? padding : '4rem 0'};
`;
const TransparentWrap = styled.div`
  padding: 4rem 0;
`;
const NavCol = styled(Col)`
  font-weight: bold;
  margin-top: 1rem;
  margin-bottom: 2rem;
  text-align: center;
`;
const NavSpan = styled.span`
  font-size: 0.8rem;
  padding: 0 2rem;
  vertical-align:top;
`;

const LobsterGram = (props) => {
  return <Fragment>
    <Helmet>
      <meta name="description" content=""/>
      <title>Case Study: Lobster Gram | RMG</title>
      <link rel="canonical" href={'https://www.rmgmedia.com/portfolio/' + props.match.params.caseStudy}/>
    </Helmet>
    <PageTitle heading="Case Study"
               subHeading="Lobster Gram"
    />
    <Container fluid>
      <Row>
        <Col col={12} noGutter={true}>
          <Img src="https://storage.googleapis.com/qa-rmgmediacom-images/CaseStudy/Lobster_Hero-Opt.jpg"/>
        </Col>
      </Row>
    </Container>
    <Container>
      <StyledRow>
        <StyledCol col={12} lg={6}>
          <IndustryTagWrap>
            <IndustryTag>Gifts</IndustryTag>
            <IndustryTag>Seafood</IndustryTag>
            <IndustryTag>Gourmet Food Delivery</IndustryTag>
          </IndustryTagWrap>
          <H3>
            About Lobster Gram
          </H3>
          <P>
            Fresh "From our shore to your door" since 1987, Lobster Gram has worked tirelessly to stay true to its roots
            and earn the reputation for being the #1 lobster, seafood, and gourmet food gift delivery company in the US.
            Since its founding by Dan "The Lobster Man" Zawacki, Lobster Gram has never wavered from its core values of
            provide a great groumet experience to its customers through a carefully selected product line that
            specializes in lobsters, seafood, steaks and more.
          </P>
          <P>
            Over the years, they have been featured on ABC, NBC, CBS, CNN, MSNBC, Wall Street Journal, Fortune, Oprah's
            "O" magazine, Every Day with Rachael Ray, Readers Digest, TIME, Men's Health, USA Today, and more. Lobster
            Gram partnered with RMG to provide a great experience, both from an ordering process as well as the product
            mix, by implementing a new mobile-friendly website and enhanced customer friendly catalog.
          </P>
        </StyledCol>
        <Col col={12} lgOffset={2} lg={4}>
          <H3>
            How We Helped
          </H3>
          <ServiceList>
            <ServiceItem>
              <ServiceTag>Creative</ServiceTag>
              <ServiceName>Mobile Responsive Design</ServiceName>
              <ServiceName>User Experience Design</ServiceName>
              <ServiceName>User Interface Design</ServiceName>
            </ServiceItem>
            <ServiceItem>
              <ServiceTag>Development</ServiceTag>
              <ServiceName>B2C & B2B Implementation</ServiceName>
              <ServiceName>Backend Development</ServiceName>
              <ServiceName>Frontend Development</ServiceName>
              <ServiceName>Software Architecture Design</ServiceName>
            </ServiceItem>
            <ServiceItem>
              <ServiceTag>Devops</ServiceTag>
              <ServiceName>Application &amp; Infrastructure Support</ServiceName>
              <ServiceName>Managed Cloud Hosting</ServiceName>
              <ServiceName>Software Development Lifecycle Management</ServiceName>
            </ServiceItem>
          </ServiceList>
        </Col>
      </StyledRow>
    </Container>
    <LightWrap>
      <Container>
        <Row>
          {/*<Col col={12} lg={6}>*/}
          {/*  <div><Img src="https://via.placeholder.com/1600x900" /></div>*/}
          {/*  <div><P>As their selection of bags and options continued to grow, Rickshaw partnered with RMG to streamline their online brand experience make it feel like it does in-store. To bring this level of customization online, RMG first replatformed Rickshaw from Magento 1 to Magento 2. During the data migration, RMG made updates to the infrastructure responsible for storing product and customer data, increasing security and functional reliability. These backend updates also allow Rickshaw to rapidly iterate on designs and store their new creations as product/option variations, greatly reducing the time-to-market for new offerings.</P></div>*/}
          {/*  <div><P>This feature immediately gave Rickshaw Bags a huge return on their investment by allowing them to remain open as an essential business and produce facemasks during the COVID-19 pandemic, increasing their pageviews and conversation rate by over 400% and their revenue by almost 500%.</P></div>*/}
          {/*  <div><Img src="https://via.placeholder.com/600x600" /></div>*/}
          {/*  <div><P>After transforming Rickshaw's core digital experience, the same treatment was applied to the rest of the business by adding new shipping methods and options, upgrading their invoice processing, and revamping their blog. Together, these changes help Rickshaw scale their business as their options continue to expand and attract new audiences through their strong content-to-commerce funnel. By working with RMG, Rickshaw Bagworks was able to bring their renowned in-store experience online and expand their reach well beyond their San Francisco storefront.</P></div>*/}
          {/*</Col>*/}
          {/*<Col col={12} lg={6}>*/}
          {/*  <div><P>At the core of Rickshaw's brand experience is the ability to customize a bag's flap, body, inner lining, bindings, buckles, labels, and straps, each of which comes in multiple colors and fabrics. Because of their extraordinary selection, Rickshaw staff's knowledgeable designers to help customers build the best bags based on their needs. In addition, Rickshaw designs and manufactures many custom fabrics, which greatly expands the audiences and applications their products cater to.</P></div>*/}
          {/*  <div><Img src="https://via.placeholder.com/800x1000" /></div>*/}
          {/*  <div><P>On the frontend, RMG built a specialized product customizer which allowed for multiple interacting filters, such as part color and fabric. This customizer also allows customers to make unique, personalized color variations which can be applied across all of Rickshaw's products. In addition, RMG redesigned Rickshaw's entire customer journey to be mobile-first, allowing customers to navigate the customization process with ease regardless of the device they use. As part of this redesign, RMG restyled most of the imagery across the site, even adding support for moving GIF images. We also streamlined Rickshaw's product, catalog, cart, and checkout pages to minimize friction and provide better responsiveness.</P></div>*/}
          {/*  <div><Img src="https://via.placeholder.com/1600x900" /></div>*/}
          {/*</Col>*/}
          <Col col={12} lg={6}>
            <Img src="https://storage.googleapis.com/qa-rmgmediacom-images/CaseStudy/LobsterGram_img_01.png"/>
          </Col>
          <Col col={12} lg={6}>
            <P>
              In 1987, Dan "The Lobster Man" Zawacki ran a one-man show and handled everything himself, from taking the
              orders to packing and shipping them from his garage. Eventually business grew and Dan was able to hire
              extra help. He decided to base the Lobster Gram Customer Service Headquarters close to his hometown in
              Chicago. In 2006, Lobster Gram opened an 18,000 square foot distribution center in Biddeford, Maine to
              handle the volume of shipped packages needed as the premier shipper of lobsters and other gourmet
              products. In 2011, Lobster Gram opened the Chicago warehouse store to serve the local marker of lobster,
              steak, and seafood lovers in the Chicagoland area. Today, Lobster Gram has built up a loyal following that
              enjoys having an affordable source for fresh lobsters flown in from Maine, along with Lobster Gram's other
              gourmet specialties. As their customer base and gourmet catalog continued to grow, Lobster Gram partnered
              with RMG to make their online brand experience as enjoyable as their products.
            </P>
          </Col>
        </Row>
      </Container>
    </LightWrap>
    <TransparentWrap>
      <Container>
        <Row>
          <Col col={12} lg={6}>
            <P>
              To give them the fastest, most responsive brand experience regardless of customer browser or device, RMG
              re-platformed Lobster Gram from Magento 1 to Magento 2, migrated all of their existing product data and
              content, and rebuilt their frontend with our PWA Accelerator. We converted their existing content to
              Magento Page Builder, so Lobster Gram's team can continue to use the drag and drop interface they know and
              love while the PWA Accelerator does the heavy lifting by rendering their changes in a React-based
              frontend.
            </P>
            <P>
              Once Lobster Gram's frontend was on PWA technology, RMG optimized their images, streamlined their
              megamenu, and added custom add-to-cart buttons on every item image, greatly reducing friction, load times,
              and number of clicks throughout the customer journey. The PWA Accelerator also handles all the logic for
              how images and information for configurable products, grouped products, and bundled products are rendered
              and presented. This is an important set of features for Lobster Gram, since it allows their shoppers to
              customize their lobster and steak holiday family dinners, as well as help them track what items can and
              cannot go in their cart (for example, removing add-on and bundled items if the associated main item is
              removed from the cart).
            </P>
          </Col>
          <Col col={12} lg={6}>
            <Img src="https://storage.googleapis.com/qa-rmgmediacom-images/CaseStudy/LobsterGram_img_02.png"/>
          </Col>
        </Row>
      </Container>
    </TransparentWrap>
    <LightWrap>
      <Container>
        <Row>
          <Col col={12} lg={6}>
            <Img src="https://storage.googleapis.com/qa-rmgmediacom-images/CaseStudy/LobsterGram_img_03.png"/>
          </Col>
          <Col col={12} lg={6}>
            <P>
              Another major set of features Lobster Gram requires is a diverse, custom variety of shipping options based
              on whether the order contains a live lobster and/or frozen items. Each option needs to allow customers to
              choose a delivery data so that gift purchases arrive on a certain day, after which the system communicated
              with ShipperHQ, one of our shipping technology partners, to calculate and return shipping rates based on
              the date and shipping method selected.
            </P>
            <P>
              Altogether, these changes streamlined and refined a customer journey that removes a lot of the complexity
              associated with ordering and shipping live animals, frozen items, and perishable goods online. The result
              for Lobster Gram is a frictionless, fast, and robust brand experience that keeps their customers happy
              coming back for seconds.
            </P>
          </Col>
        </Row>
      </Container>
    </LightWrap>
    <LightWrap>
      <Container>
        <Row>
          <NavCol col={12}>
            <ViewMoreLink textColor="#000" arrowWidth='0.6rem' directionReversed
                          to={`/portfolio/h-e-b`}
                          buttonText="H-E-B"/>
            <NavSpan>/</NavSpan>
            <ViewMoreLink textColor="#000" arrowWidth='0.6rem' to={`/portfolio/cbdmd`}
                          buttonText="cbdMD"/>
          </NavCol>
        </Row>
      </Container>
    </LightWrap>
    <GetInTouch title="Get In Touch"
                text="You could be our next case study."
                buttonText="Let's talk"
                useArrow
    />
    <PageNavigation prev="capabilities" next="insights"/>
  </Fragment>;
};

export default withRouter(LobsterGram);